"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;

var tslib_1 = require("tslib");

var ui_overlay_1 = require("@hopin-team/ui-overlay");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

exports.Overlay = (0, styled_components_1.default)(ui_overlay_1.Overlay)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  backdrop-filter: none;\n  height: auto;\n  width: auto;\n  bottom: 0;\n  right: 0;\n  ", "\n"], ["\n  backdrop-filter: none;\n  height: auto;\n  width: auto;\n  bottom: 0;\n  right: 0;\n  ", "\n"])), function (_a) {
  var clearOverlay = _a.clearOverlay;
  return clearOverlay && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      background-color: transparent;\n    "], ["\n      background-color: transparent;\n    "])));
});
var templateObject_1, templateObject_2;